import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'Compass/core/App';

let container: HTMLElement | null = null;

document.addEventListener('DOMContentLoaded', function() {
  if (!container) {
    container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container)
    root.render(<App/>);
  }
});

// Opt-in to Webpack hot module replacement
if (module.hot) {
  module.hot.accept();
}
